<template>
  <div>
    <Carousel2 v-if="IsMobile" />
    <template v-else>
      <Carousel />
      <Conteudo />
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Carousel from "@/components/Carousel.vue";
import Carousel2 from "@/components/Carousel2.vue";
import Conteudo from "@/components/Conteudo.vue";

export default {
  components: {
    Carousel,
    Carousel2,
    Conteudo
  },
  created() {
    console.log(
      "App-Home navigator.userAgent: ",
      navigator.userAgent,
      this.IsMobile
    );
  },

  watch: {
    IsMobile(val) {
      console.log("Home IsMobile: ", this.IsMobile);
    }
  },
  computed: mapState([
    // map this.count to store.state.count
    "IsMobile"
  ])
};
</script>

<style></style>
